import styled from 'styled-components'

const ICON_SIZE = 24
const ICON_GAP = 12

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	gap: 16px;
	padding: 24px 18px;
	border-radius: 20px;
	background: ${props => props.theme.colors.brand.backgroundBlue};
`

export const Header = styled.div`
	display: flex;
	align-items: center;
	gap: ${ICON_GAP}px;
`

export const MessageWrapper = styled.div`
	padding-left: ${ICON_SIZE + ICON_GAP}px;
`
